import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {DriverPoliciesContent as SharedDriverPolicies} from "@/customComponents/globalComponents/policiesContent.jsx";
import {bookingPolicyValues} from "@/customComponents/globalComponents/policyValues.js";

// Booking-flow adapter: shared content with values from /trips/calculate-policies.
export function DriverPoliciesContent() {
    return <SharedDriverPolicies policy={bookingPolicyValues()}/>;
}

export function DriverPolicies({setStep, closeModal, previousStep}) {
    const backStep = previousStep || (storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing");
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={backStep} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <DriverPoliciesContent/>
        </>
    );
}
export default DriverPolicies;
